import { useState } from 'react';
import type { CSSProperties } from 'react';
import { Icon } from '../core/Icon';

export interface SearchFieldProps {
    value?: string;
    onChange?: (value: string) => void;
    placeholder?: string;
    /** Atalho exibido à direita quando o campo está vazio, ex.: `⌘K`. */
    shortcut?: string;
    width?: number | string;
    /** Nome acessível. O `placeholder` sozinho não nomeia o campo. */
    ariaLabel?: string;
    style?: CSSProperties;
}

export function SearchField({
    value = '', onChange, placeholder = 'Buscar', shortcut, width = 280, ariaLabel, style,
}: SearchFieldProps) {
    const [focus, setFocus] = useState(false);
    return (
        <div
            style={{
                /* `maxWidth` 100%: num contêiner mais estreito que `width` (a topbar a 768 px) o
                   campo encolhe o texto, em vez de sair cortado com o atalho junto. */
                display: 'flex', alignItems: 'center', gap: 8, width, maxWidth: '100%', minWidth: 0, boxSizing: 'border-box', height: 42, padding: '0 10px',
                background: focus ? 'var(--surface)' : 'var(--surface-secondary)',
                border: `1px solid ${focus ? 'var(--border-focus)' : 'var(--border)'}`,
                borderRadius: 'var(--radius-control)', boxShadow: focus ? 'var(--focus-ring)' : 'none',
                transition: 'var(--transition-control)', ...style,
            }}
        >
            <Icon name="search" size={15} style={{ color: 'var(--neutral-500)' }} />
            <input
                type="search"
                value={value}
                placeholder={placeholder}
                aria-label={ariaLabel ?? placeholder}
                onChange={(e) => onChange?.(e.target.value)}
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
                style={{ flex: 1, minWidth: 0, border: 0, outline: 'none', background: 'transparent', fontFamily: 'var(--font-ui)', fontSize: 13.5, color: 'var(--text-primary)' }}
            />
            {value ? (
                <button
                    type="button" onClick={() => onChange?.('')} aria-label="Limpar busca"
                    style={{ border: 0, background: 'transparent', cursor: 'pointer', color: 'var(--neutral-500)', padding: 2 }}
                >
                    <Icon name="x" size={14} />
                </button>
            ) : shortcut ? (
                <kbd style={{ flex: '0 0 auto', fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text-tertiary)', border: '1px solid var(--border)', borderRadius: 4, padding: '1px 5px', background: 'var(--surface)' }}>
                    {shortcut}
                </kbd>
            ) : null}
        </div>
    );
}
